import { tiresWarranty } from "./tires-warranty-en.i18n";

export const en = {
  tiresWarranty
}
